import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-game-teller',
  templateUrl: './game-teller.component.html',
  styleUrls: ['./game-teller.component.less']
})
export class GameTellerComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
